import Moment from 'moment';
import { jwtDecode } from 'jwt-decode';
import { getPreApprovalObj } from './quoteHelpers';

// a token with less than this remaining is treated as already expired, so
// nothing starts a flow that would outlive it mid-request
export const tokenExpiryBufferMs = 5 * 60 * 1000;

const Helpers = {
	preApprovalEnums: {
		pre: 'pre',
		save: 'save',// madeup
		progress: 'Open-InProgress',
		approved: 'Open-Approved',
		//new
		notapproved: 'Open-NotApproved',
		// expired: 'Resolved-Expired',
		converted: 'Resolved-Converted',
		ineligible: 'Open-Ineligible',
		// closed: 'Resolved-Closed',
		restricted: 'Restricted-Quote'// madeup
	},
	isQuoteAbleToSave(state: any): boolean {
		if (Helpers.isQuoteIdSame(state.quoteCreate, state.retrieveQuote, state.updateRepayments)){
			const preApproval = getPreApprovalObj(state);
			const status = preApproval.preApproval.preApprovalStatus;
			if (!status || status == Helpers.preApprovalEnums.progress){
				return true;
			}
			else {
				console.log('isQuoteAbleToSave incompatible status');
				return false;
			}
		}
		else {
			console.log('isQuoteAbleToSave quoteId not the same - true');
			return true;
		}
	},
	isQuoteIdSame(quoteCreate: any, retrieveQuote: any, updateRepayments: any): boolean {
		const retrieveRes = retrieveQuote.response;
		const retrieveCi = retrieveRes.customerDomain.customerInteraction;
		const currentQuoteId = retrieveCi.quote.quoteId || quoteCreate.createQuoteResponse.customerDomain.customerInteraction.quote.quoteId;
		const originatedQuoteId = updateRepayments.alfaFinancialResponse.customerDomain.customerInteraction.preApproval.originatedQuoteId || retrieveCi.preApproval.originatedQuoteId;
		console.log('isQuoteIdSame', currentQuoteId === originatedQuoteId,',currentQuoteId:',currentQuoteId,'originatedQuoteId:',originatedQuoteId)
		return currentQuoteId === originatedQuoteId;
	},
	canOpenOtpModal(routeName: string, stepNumber: number): boolean {
		return routeName == 'CheckoutPage' && stepNumber > 1;
	},
	getRestoreUrl(state: any, $route: any): string {
		const accessToken = state.forgeRockApp.tokens.accessToken;
		const atObj: any = accessToken ? jwtDecode(accessToken) : {};
		const omniGuid = atObj.omni_guid || '';
		const params = new URLSearchParams();
		params.set('omni_guid', omniGuid || '');
		params.set('case', state.quoteCreate.pegaCaseTracking || '');
		params.set('guid', state.quoteCreate.guestRateIdentifier || '');
		params.set('m', state.vehicle.materialCode || '');

		if (Helpers.getCookie("financeoptions")){
			params.set('financeOptions', Helpers.getCookie("financeoptions"));
		}
		else {
			const c = `${state.app.financeDeposit}_${state.app.loanTerm}_${state.app.kmsPerYear}`;
			params.set('financeOptions', c);
		}

		if ($route.query.tpr_source){
			params.set('tpr_source', $route.query.tpr_source || '');
		}
		if ($route.query.b){
			params.set('b', $route.query.b);
		}
		if ($route.query.v){
			params.set('v', $route.query.v);
		}
		if ($route.query.ps){
			params.set('ps', $route.query.ps);
		}
		if ($route.query.utm_source){
			params.set('utm_source', $route.query.utm_source);
		}
		if ($route.query.utm_term){
			params.set('utm_term', $route.query.utm_term);
		}
		if ($route.query.utm_medium){
			params.set('utm_medium', $route.query.utm_medium);
		}
		if ($route.query.utm_campaign){
			params.set('utm_campaign', $route.query.utm_campaign);
		}
		if ($route.query.enquiry_source){
			params.set('enquiry_source', $route.query.enquiry_source);
		}
		if ($route.query.track_my_car_status){
			params.set('track_my_car_status', $route.query.track_my_car_status);
		}
		if ($route.query.model){
			params.set('model', $route.query.model);
		}
		if ($route.query.grade){
			params.set('grade', $route.query.grade);
		}
		console.log('RESTORE URL', `${location.protocol}//${location.host}/finance/restore-quote?${params.toString()}`);
		return `${location.protocol}//${location.host}/finance/restore-quote?${params.toString()}`
	},
	blankJwtToken: {
		"sub": "",
		"cts": "",
		"auth_level": 0,
		"auditTrackingId": "",
		"subname": "",
		"iss": "",
		"tokenName": "",
		"token_type": "",
		"authGrantId": "",
		"client_id": "",
		"aud": "",
		"nbf": 0,
		"grant_type": "",
		"scope": [],
		"auth_time": 0,
		"realm": "",
		"exp": 0,
		"iat": 0,
		"expires_in": 0,
		"jti": "",
		"omni_guid": ""
	},
	blankLastSavedQuote: {
		"dealerID": 0,
		"omniGuid": "",
		"trackingID": "",
		"quoteID": "",
		"eligibilityID": "",
		"eligibilityOutcome": "",
		"preApprovalStatus": "",
		"lastSavedDate": "",
		"vin": "",
		"vsid": "",
		"materialcode": "",
		"batchNumber": "",
		"productionDate": "",
		"inStock": false,
		"driveawayPrice": 0,
		"gfv": 0,
		"nvic": "",
		"model": "",
		"fullDescription": "",
		"tprGuid": ""
	},
	blankUpdateQuote: {
		errorResponse: null,
		httpStatusCode: 0,
		failedPost: null,
		success: false,
		failedCorellation: ""
	},
	blankRetrieveQuote: {
		"response": {
			"customerDomain": {
				"customer": {
					"trackingId": "",
					"customerId": "",
					"livingSituation": "",
					"propertySituation": true
				},
				"person": {
					"salutation": null,
					"givenName1": "",
					"givenName2": null,
					"surname": "",
					"dateOfBirth": "",
					"maritalStatus": null
				},
				"contactEmailAddress": [
					{
						"email": ""
					}
				],
				"contactTelephone": [
					{
						"telephoneNumber": ""
					}
				],
				"address": [
					{
						"geoCode": 0,
						"streetName": "",
						"subPremise": null,
						"unitNumber": null,
						"streetType": null,
						"streetNumber": "",
						"addressLine1": null,
						"citySuburb": "",
						"stateProvince": "",
						"postZipCode": "",
						"countryCode": "",
						"fullAddress": "",
						"addressPurposeType": null,
						"primaryAddressIndicator": null
					}
				],
				"driversLicence": {
					"licenceType": null,
					"licenceNumber": "",
					"expiryDate": null,
					"state": null,
					"country": ""
				},
				"customerInteraction": {
					"quote": {
						"quoteId": "",
						"originatingQuoteId": null,
						"status": "",
						"createdDate": "",
						"expiryDate": "",
						"eligibilityId": "",
						"eligibilityOutcome": "",
						"salesChannelName": "",
						"borrowerType": "",
						"feeAmount": 0,
						"establishmentFee": 0,
						"ppsrFee": 0,
						"monthlyAccountFee": null,
						"onChargedDealerAgencyFee": 0
					},
					"preApproval": {
						"preApprovalId": null,
						"preApprovalStatus": null,
						"originatedQuoteId": null,
						"preApprovalExpiryDate": null
					}
				},
				"financialDetailRetailFinance": {
					"repaymentFrequency": "",
					"repaymentAmount": 0,
					"regularInstallmentAmount": null,
					"interestRate": 0,
					"comparisonRate": 0,
					"loanTerm": 0,
					"endOfTermOdometerReading": null,
					"financier": "",
					"financeBrand": ""
				},
				"financeAccount": {
					"totalAmountFinanced": 0,
					"balloonAmount": 0,
					"depositAmount": 0
				}
			},
			"dealerDomain": {
				"dealer": {
					"id": 0,
					"metroRural": "",
					"make": "",
					"region": ""
				}
			},
			"productDomain": {
				"product": {
					"productSubCategory": "",
					"productTitle": "",
					"productType": ""
				}
			},
			"vehicleDomain": {
				"vehicle": {
					"vehicleCode": "",
					"vehicleBuildDate": ""
				},
				"vehicleSpecification": {
					"vehicleYear": "",
					"vehicleMake": "",
					"vehicleModel": "",
					"vehicleModelVariant": "",
					"vehicleImage": ""
				},
				"vehicleCatalogue": {
					"lifeStatus": ""
				},
				"vehiclePrice": {
					"basePrice": 0,
					"priceType": null
				}
			},
			"loanType": 0,
			"financeHeading": "",
			"disclaimer": ""
		},
		"errorResponse": null,
		"httpStatusCode": 0,
		"failedCorellation": "",
		"success": false
	},
	blankUpdateRepayments: {
		"alfaFinancialResponse": {
			"customerDomain": {
				"financialDetailRetailFinance": {
					"repaymentAmount": 0,
					"comparisonRate": 0,
					"interestRate": 0,
					"monthlyRepaymentAmount": 0
				},
				"financeAccount": {
					"balloonAmount": 0,
					"calculatedBalloonAmount": 0,
					"maxBalloonAmount": 0,
					"maxDepositAmount": 0,
					"totalAmountFinanced": 0
				},
				"customerInteraction": {
					"quote": {
						"eligibilityId": "",
						"eligibilityOutcome": "",
						"onChargedDealerAgencyFee": 0,
						"establishmentFee": 0,
						"ppsrFee": 0,
						"accountFee": 0
					},
					"preApproval": {
						"preApprovalId": "",
						"preApprovalStatus": "",
						"originatedQuoteId": "",
						"preApprovalExpiryDate": ""
					}
				},
				"additionalOutput": {
					"totalKms": 0,
					"kmsPerYear": 0,
					"disclaimer": "",
					"financeHeading": ""
				}
			}
		},
		"errorResponse": null,
		"httpStatusCode": 0,
		"failedCorellation": "",
		"success": false,
		"failedRequest": null
	},
	blankQuoteCreate: {
		"createQuoteResponse": {
			"customerDomain": {
				"customer": {
					"trackingId": ""
				},
				"financialDetailRetailFinance": {
					"rateMatrix": []
				},
				"customerInteraction": {
					"quote": {
						"eligibilityId": "",
						"eligibilityOutcome": "",
						"onChargedDealerAgencyFee": 0,
						"establishmentFee": 0,
						"ppsrFee": 0,
						"accountFee": 0
					},
					"preApproval": {
						"preApprovalId": "",
						"preApprovalStatus": "",
						"originatedQuoteId": "",
						"preApprovalExpiryDate": ""
					}
				}
			}
		},
		"compactFinanceMatrixResponse": [],
		"errorResponse": null,
		"httpStatusCode": 0,
		"failedPost": null,
		"success": false,
		"guestRateIdentifier": "",
		"validityDate": "",
		"pegaGuid": "",
		"pegaCaseTracking": ""
	},

	tokenExpiryBufferMs,
	isTokenEffectivelyExpired(expiry: any): boolean {
		if (!expiry) return true;
		const d = new Date(expiry);
		if (isNaN(d.getTime())) return true;
		return d.getTime() - tokenExpiryBufferMs <= Date.now();
	},
	contactMethodOptions: [
		'Email',
		'Mobile'
	],
	expectedPurchaseOptions: [
		'ASAP', 'Within The Month', 'Undecided'
	],
	livingStatus: [
		{value: "2", label: 'Own Home (Mortgage)'},
		{value: "1", label: 'Own Home (No Mortgage)'},
		{value: "3", label: 'Renting'},
		{value: "4", label: 'Boarding'},
		{value: "5", label: 'Living With Parents'}
	],
	getFinanceTypeFromCookie(fallback: number): number {
		// financeoptions is deposit_term_kmsOrBalloon_ft; pre-fixed-rate cookies had no ft segment
		const sliders = Helpers.getCookie("financeoptions");
		if (!sliders){
			return fallback;
		}
		const financeOptions = sliders.split("_");
		if (financeOptions.length == 3){
			financeOptions.push("1");
		}
		const ft = financeOptions.length > 3 ? parseInt(financeOptions[3]) : NaN;
		return isNaN(ft) ? fallback : ft;
	},
	resetAllCookies(){
		console.log('resetting cookies');
		const cd = ';path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT';
		const pegacaseCookie = Helpers.getCookie('tprcaseid') || '';
		const tokenCookie = Helpers.getCookie('token') || '';
		const ogCookie = Helpers.getCookie('omniguid') || '';
		const tprguidCookie = Helpers.getCookie('tprguid') || '';
		const ogExpiryCookie = Helpers.getCookie('omniguidexpiry') || '';
		const notQuantumCookie = Helpers.getCookie('notquantumid') || '';
		const financeOptionsCookie = Helpers.getCookie('financeoptions') || '';
		if (tokenCookie){
			document.cookie = 'token=' + tokenCookie + cd;
		}
		if (ogCookie){
			document.cookie = 'omniguid=' + ogCookie + cd;
		}
		if (tprguidCookie){
			document.cookie = 'tprguid=' + tprguidCookie + cd;
		}
		if (pegacaseCookie){
			document.cookie = 'tprcaseid=' + pegacaseCookie + cd;
		}
		// session-derived cookies that would otherwise re-seed a restarted quote
		if (ogExpiryCookie){
			document.cookie = 'omniguidexpiry=' + ogExpiryCookie + cd;
		}
		if (notQuantumCookie){
			document.cookie = 'notquantumid=' + notQuantumCookie + cd;
		}
		if (financeOptionsCookie){
			document.cookie = 'financeoptions=' + financeOptionsCookie + cd;
		}
	},
	setFinanceStoreAndCookies(state: any, $store: any, financeData: any, appData: any){
		const d = new Date();
		d.setDate(d.getDate() + 7 * 2);
		const ft = financeData.financeType || 1;
		const deposit = financeData.financeDeposit || 0;
		const term = state.app.loanTerm || 0;
		const kmsOrBalloon = ft == 1 ? state.app.kmsPerYear || 0 : state.app.balloonPercentage || 0;

		$store.commit('setFinance', financeData);
		$store.commit('setAppFinanceOptions', {
			financeDeposit: financeData.financeDeposit,
			termsInYears: appData.loanTerm,
			kms: appData.kmsPerYear,
			balloonPercentage: appData.balloonPercentage,
			financeType: financeData.financeType
		});

		Helpers.setFinanceOptionCookie(d.toString(), deposit, term, kmsOrBalloon, ft);
	},
	setFinanceOptionCookie(validityDate: string, deposit: number | string, term: number | string, kms: number | string, ft: number) {
		let dateexp = new Date(validityDate);
		const expires = "expires=" + dateexp.toString();
		const cookieData = ";" + expires + ';path=/';
		document.cookie = "financeoptions=" + deposit + '_' + term + '_' + kms + '_' + (ft || 1) + cookieData;
		console.log('set financeoptions cookies with ' + deposit + '_' + term + '_' + kms + '_' + (ft || 1) + cookieData);
	},
	getMaxBalloonPercentage(termsInYears: number): number {
		switch (termsInYears) {
			case 1:
				return 70;
			case 2:
				return 60;
			case 3:
				return 50;
			case 4:
				return 40;
			case 5:
				return 35;
			default:
				return 0;
		}
	},
	setTokenCookie(token: any, tprExpiry: any){
		if (!token) return;
		const obj = (jwtDecode as any)(token);
		if (obj.auth_level < 100) return;
		console.log('setTokenCookie af2');

		const dateexp = new Date(parseInt(`${obj.exp}000`));
		const expires = "expires="+ dateexp.toString();
		const cookieData = ";" + expires + ';path=/';
		document.cookie = "token=" + token + cookieData;

		if (tprExpiry){
			Helpers.setOmniGuidCookie(obj.omni_guid, tprExpiry);
		}
	},
	setOmniGuidCookie(guid: any, tprExpiry: any){
		let dateexp = new Date(tprExpiry);
		let expires = "expires="+ dateexp.toString();
		let cookieData = ";" + expires + ';path=/';
		document.cookie = "omniguid=" + guid + cookieData;
		document.cookie = "omniguidexpiry=" + tprExpiry + cookieData;
		console.log('setOmniGuidCookie', guid, tprExpiry);
	},
	// the finance product the quote was last saved with (CreateQuote /
	// UpdateQuote), keyed by case so a reload can still tell a product change
	// from a slider-only change (App.savedQuoteLoanType). Same expiry as the
	// tprcaseid cookie
	setTprLoanTypeCookie(pegaCaseTracking: any, validityDate: any, loanType: number){
		const caseId = (pegaCaseTracking || '').replace('TPR-', '');
		if (!caseId || !loanType) return;
		const dateexp = new Date(validityDate);
		const expires = isNaN(dateexp.getTime()) ? '' : ';expires=' + dateexp.toString();
		document.cookie = 'tprloantype=' + caseId + '_' + loanType + expires + ';path=/';
	},
	getTprLoanTypeCookie(pegaCaseTracking: any): number {
		const caseId = (pegaCaseTracking || '').replace('TPR-', '');
		const parts = (Helpers.getCookie('tprloantype') || '').split('_');
		if (!caseId || parts.length != 2 || parts[0] != caseId) return 0;
		const ft = parseInt(parts[1]);
		return isNaN(ft) ? 0 : ft;
	},
	setTprGuidCookie(pegaCaseTracking: any, validityDate: any, guid: any){
		let caseId = pegaCaseTracking.replace('TPR-', '');
		let dateexp = new Date(validityDate);
		let expires = "expires="+ dateexp.toString();
		let cookieData = ";" + expires + ';path=/';
		document.cookie = "tprguid=" + guid + cookieData;
		document.cookie = "tprcaseid=" + caseId + cookieData;
		console.log('set cookies with ' + guid + ', ' + cookieData);
	},
	setObject: (obj: any, obj2: any) => {
		for (const key in obj2) {
			if (obj2.hasOwnProperty(key)) {
				obj[key] = obj2[key]
			}
		}
	},
	getEnquirySources(): any {
		return {
			'Normal': 1,
			'KIOSK_SHOWROOM': 2,
			'KIOSK_SERVICE': 3,
			'QR_SHOWROOM': 4,
			'QR_SERVICE': 5,
			'SDL_QR': 6
		};
	},
	getLongestCommonStartingSubstring(arr1: Array<any>): string {
		const arr= arr1.concat().sort();
		const a1= arr[0];
		const a2= arr[arr.length-1];
		const L= a1.length;
		let i= 0;
		while(i< L && a1.charAt(i)=== a2.charAt(i)) i++;
		return a1.substring(0, i);
	},
	formattedDateMinusOneDay(d: any): string {
		const m = Moment(d).subtract(1, 'days');
		return m.format('Do MMMM YYYY');
	},
	formattedDate(d: any): string {
		const m = Moment(d)
		return m.format('Do MMMM YYYY');
	},
	shortFormattedDate(d: any): string {
		const m = Moment(d)
		return m.format('D MMM YYYY');
	},
	extractDisclaimerKeys(disclaimer: string): Array<any>{
		const keys = [];
		const arr = disclaimer.split('[');
		for (let i = 0; i != arr.length; ++i){
			if (arr[i].length){
				const arr2 = arr[i].split(']');
				if (arr2.length){
					keys.push('['+arr2[0]+']');
				}
			}
		}
		return keys;
	},
	getCookie(name: string): string {
		const match = document.cookie.match(new RegExp(name + '=([^;]+)'));
		if (match) return match[1];
		return '';
	},
	getNumberFromString(s: string): number {
		return parseInt(s.replace(/[^\d]/g, ''));
	},
	getFormattedPrice(p: number, force2Digit?: boolean): string {
		const whole = Math.floor(p);
		const remainder = p - whole;
		const formatter = new Intl.NumberFormat('en-AU', {
			style: 'currency',
			currency: 'AUD',
			minimumFractionDigits: force2Digit || remainder ? 2 : 0
		});
		return formatter.format(p);
	},
	getColour(code: string): string {
		const colourMap: any = {
			'040': '#fff',
			'219': '#000',
			'218': '#000',
			'LB20': '#000',
			'3U5': 'red',
			'EA20': '#000'
		};
		return code ? colourMap[code] || '' : '';
	},
	clog(v: any): void {
		if (-1 != location.hostname.indexOf('tpr.tfa.local') || -1 != location.hostname.indexOf('test.dealer') || -1 != location.hostname.indexOf('sit4')){
			console.log(v);
		}
	}
}
export default Helpers;
